import * as css from 'css/exports.module.scss';

import { AsyncStateNotification } from '@ui/notifications';
import { FormInstance } from 'antd/es/form';
import { getDirectParent } from '@lib/popups';
import { SonarCard } from '@ui/general';
import { TagDescriptionInput } from './TagDescriptionInput';
import { TagNameInput } from './TagNameInput';
import { TagOwnersInput } from './TagOwnersInput';
import { useCreateTag } from '@hooks';

import { Button, Col, Form, Row } from 'antd';
import { COPY_SPECIFIC, NOTIFICATIONS_COPY, TAG_COLORS } from '@sonar-software/sonar-ts-constants';
import React, { useEffect, useRef, useState } from 'react';

interface FormValues {
	description: string;
	name: string;
	userIds: string[];
}

export const CreateTag: React.FC = () => {
	const [ hexColor, setHexColor ] = useState(TAG_COLORS[ 0 ]);
	const formRef = useRef<FormInstance>(null);

	const { isProcessing, isSuccessful, request, reset } = useCreateTag();

	const handleOnSubmit = (values: FormValues) => {
		const { description, name, userIds } = values;
		const ownerIds = userIds?.length ? userIds.map(Number) : [];

		request({
			description: description ?? '',
			hexColor,
			name,
			ownerIds
		});
	};

	useEffect(() => {
		if (isSuccessful) {
			formRef.current?.resetFields();
			setHexColor(TAG_COLORS[ 0 ]);
		}
	}, [ isSuccessful ]);

	return (
		<>
			<SonarCard
				className='tag-create-card'
				title={ COPY_SPECIFIC.CREATE_TAG }>
				<Form
					className='create'
					onFinish={ handleOnSubmit }
					ref={ formRef }>
					<Row gutter={ [ Number(css.size16), 0 ] }>
						<Col span={ 6 }>
							<TagNameInput
								getPopupContainer={ getDirectParent }
								hexColor={ hexColor }
								name='name'
								onColorClick={ setHexColor } />
						</Col>
						<Col span={ 18 }>
							<TagOwnersInput name='userIds' />
						</Col>
					</Row>
					<TagDescriptionInput name='description' />
					<Row>
						<Button
							className='tag-create-button'
							disabled={ isProcessing }
							htmlType='submit'
							id='tag-create-button'
							loading={ isProcessing }
							type='primary'>
							{ COPY_SPECIFIC.CREATE }
						</Button>
					</Row>
				</Form>
			</SonarCard>
			<AsyncStateNotification
				errored={ NOTIFICATIONS_COPY.ERROR_POST_TAG }
				failed={ NOTIFICATIONS_COPY.FAILED_POST_TAG }
				received={ NOTIFICATIONS_COPY.SUCCESS_POST_TAG }
				resetAction={ reset }
				stateSelector={ useCreateTag.selectors.state } />
		</>
	);
};
